module.exports = __webpack_public_path__ + "img/ques.ffb2ee4a.png";